import { Avatar, Box, Button, Center, Flex, FormControl, FormErrorMessage, HStack, Image, Text, Textarea, useToast, VStack } from "@chakra-ui/react"
import { useFormik } from "formik"
import moment from "moment"
import { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import Loading from "../../../components/common/Loading"
import TrDashboardHeader from "../../../components/common/TrainerDashboardHeader"
import TrainerSidenav from "../../../components/trainer/courses/Sidenav"
import rarrow from "../../../img/rarrow.svg"
import { IDiscussionTopic } from "../../../models/trainer-discussiontopic.model"
import trainercoursesService from "../../../services/trainer/trainercourses.service"
import trainerRoutes from "../routes"

const TrEachDiscussion = () => {
    const [topic, setTopic] = useState<IDiscussionTopic | any>([]);
    const [discussion, setDiscussion] = useState<IDiscussionTopic | any>([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const toast = useToast();
    const params = useParams();
    const course_id: any = params.course_id;
    const discussion_id: any = params.id;
    const courseName: null | string = localStorage.getItem("courseName");

    useEffect(() => {
        if (discussion_id)
            
            trainercoursesService.getDiscussion(discussion_id).then(
                (res) => {
                    
                    setDiscussion(res.data);
                }
            )
            trainercoursesService.getDiscussionTopic(discussion_id).then(
                (res) => {
                    
                    setTopic(res.data)
                    setLoading(false);
                }
            )
    }, [discussion_id])

    // const formik = useFormik({
    //     validate: (values: any) => {
    //         const errors: any = {};
    //         if (!values.message) {
    //             errors.message = 'Reply field is required'
    //         }
    //         return errors;
    //     },
    //     initialValues: {
    //         message: ''

    //     },
    //     onSubmit: async (values) => {
    //         const replyInfo: any = {
    //             message: values.message,
    //         }
    //         
    //         try {
    //             const replyInfoRes = await trainercoursesService.replyDiscussion(replyInfo, discussion_id)
    //             if (replyInfoRes.status === 'success') {
    //                 
    //             }
    //         } catch (error: any) {
    //             toast({
    //                 title: "Discussion Reply",
    //                 description: `${error.response.data.message}`,
    //                 status: "error",
    //             })
    //         }
    //     }
    // })

    const formik = useFormik({
            validate: (values: any) => {
                const errors: any = {};
                if (!values.message) {
                    errors.message = 'Description is required'
                }
                return errors;
            },
            initialValues: {
                message: '',
           
            },
            onSubmit: async (values) => {
    
                const newDiscussionInfo: any = {
                    message: values.message,
                }
                
    
                try {
                    // post discussion api here
                    const newDiscussionResponse = await trainercoursesService.createNewDiscussion(newDiscussionInfo, discussion_id)
                    
                    if(newDiscussionResponse.status === 'success')
                        toast({
                            title: "Discussion",
                            description: 'Discussion replied successfully',
                            status: "success",
                        })
                        formik.resetForm();
                        trainercoursesService.getDiscussion(discussion_id).then(
                            (res) => {
                                setDiscussion(res.data);
                            }
                        )
    
                } catch (error:any) {
                    toast({
                        title: "Discussion",
                        description: `${error.response.data.message}`,
                        status: "error",
                    })
                }
            }
    })

    return (
        <>
            <TrDashboardHeader />
            <Box bg='#F9F8F8' minHeight='90vh' pt={"1.5rem"} pb={"2rem"}>
                <Flex width='90%' mx='auto' pt='80px'>
                    <TrainerSidenav />
                    <VStack width={{lg:'80%', md:'85%', sm:'93%', base:'93%'}}>
                    <HStack width={"100%"} height={"2rem"}>
                  <Text as="span" fontSize={"20px"}>
                    {courseName && courseName.replaceAll(/"/g, "")}
                  </Text>
                  <Image src={rarrow} />
                  <Text as="span" fontSize={"20px"} color={"#616161"}>
                    Discussions
                  </Text>
                </HStack>
                    <Box width={"100%"} mx='auto' mb="1rem" bg='white' padding={{lg:'2.5rem',md:"2rem", sm:'1.4rem', base:'1.4rem'}}>
                        <Text color='#1E1E1E' fontSize={{lg:'28px', md:'26px', sm:'24px',base:'24px'}} pb='30px' fontWeight='600'>Discussions</Text>
                        <Flex justifyContent='flex-start' alignItems='center' mb='30px'>
                            <Button py='13px' px='30px' type="submit" variant={'outline'} fontSize={11} onClick={() => navigate(trainerRoutes.trainerCourses.DiscussionLink(course_id))} colorScheme='red' size='sm'>
                                BACK
                            </Button>
                            {/* <Button py='20px' px='30px' mt='30px' onClick={() => navigate(`/trainer/course/${course_id}/discussion/${discussion_id}/new-discussion`)} fontSize={12} borderRadius={0} colorScheme='red' size='sm'>
                                NEW DISCUSSION
                            </Button> */}
                        </Flex>
                        {
                            loading ? <Loading/> :
                                <Box>
                                    <Flex pb='20px' mb='30px' pr='30px' py='25px' borderBottom='1px solid ' borderColor='lightgrey'>
                                        <Box mr='20px' ml='45px'>
                                            <Center mx='auto' mb='20px' bg='#C4C4C4' width='40px' height='40px' borderRadius='20px'>
                                                <Avatar width='100%' height='100%' borderRadius='50%' name={topic?.user?.name} src='https://bit.ly/broken-link' />
                                            </Center>
                                        </Box>
                                        <Box mr='45px' width='90%' >
                                            <Text fontWeight='600' color='#616161' fontSize='16px'>{topic?.title}</Text>
                                            <Text fontWeight='400' color=' #B9B9B9' mb='10px' fontSize={{ lg: '12px', md: '11px', sm: '10px', base: '10px' }}>
                                                Posted {moment(topic.created_at).fromNow()} by {topic.user.name} 
                                                <Text as='span' fontSize={{lg: '10px', md: '9px', sm: '8px', base: '8px'}} padding='0.2rem' bgColor='#FFF4F4' color='red' borderRadius='4px' letterSpacing={'0.5px'} marginLeft={'0.3rem'} fontWeight={'700'}>
                                                    {" "}{topic.user.category}
                                                </Text>
                                            </Text>
                                            <Text mb='10px' fontSize='14px' fontWeight='500' color=' #B9B9B9'>
                                                {topic?.description}
                                            </Text>
                                        </Box>
                                    </Flex> 
                                    {
                                        discussion?.map((each: any, index: any) => (
                                            <Flex key={index} pb='20px' mb='30px' pr='30px' py='25px' borderBottom='1px solid ' borderColor='lightgrey'>
                                                <Box mr='20px' ml='45px'>
                                                    <Center mx='auto' mb='20px' bg='#C4C4C4' width='40px' height='40px' borderRadius='20px'>
                                                        {/* <Image width='40px' height='40px' borderRadius='20px' src={bolaji} /> */}
                                                        <Avatar width='100%' height='100%' borderRadius='50%' name={each.user.name} src='https://bit.ly/broken-link' />
                                                    </Center>
                                                </Box>
                                                <Box mr='45px' width='90%' >
                                                    <Box>
                                                       <Text fontWeight='400' color=' #B9B9B9' mb='10px' fontSize={{ lg: '12px', md: '11px', sm: '10px', base: '10px' }}>
                                                            replied {moment(each.created_at).fromNow()} by {each.user.name} 
                                                            <Text as='span' fontSize={{lg: '10px', md: '9px', sm: '8px', base: '8px'}} padding='0.2rem' bgColor='#FFF4F4' color='red' borderRadius='4px' letterSpacing={'0.5px'} marginLeft={'0.3rem'} fontWeight={'700'}>
                                                                {" "}{each.user.category}
                                                            </Text>
                                                        </Text>
                                                        <Text mb='10px' fontSize='14px' fontWeight='500' color=' #B9B9B9' >
                                                            {each.body}
                                                        </Text>
                                                    </Box>
                                                </Box>

                                            </Flex>
                                        ))
                                    }
                                    <FormControl mt={6} id="message" isInvalid={(formik.errors.message && formik.touched.message) ? true : false}>
                                        <Textarea
                                            p={4}
                                            bg="inputText.500"
                                            fontSize={12}
                                            height="150px"
                                            size="sm"
                                            placeholder="enter reply here..."
                                            name="message"
                                            onChange={formik.handleChange}
                                            value={formik.values.message}
                                        />
                                        <FormErrorMessage fontSize={12} >{formik.errors.message}</FormErrorMessage>
                                    </FormControl>
                                    <Flex justifyContent='flex-end'>
                                        <Button py='13px'
                                            px='30px'
                                            mt='30px'
                                            type="submit"
                                            fontSize={11}
                                            borderRadius={0}
                                            colorScheme='red'
                                            size='sm'
                                            isLoading={formik.isSubmitting}
                                            onClick={() => formik.handleSubmit()}
                                        >
                                            REPLY
                                        </Button>
                                    </Flex>
                                </Box>
                        }
                    </Box>
                    </VStack>
                </Flex>
            </Box>
        </>
    )
}

export default TrEachDiscussion;